import React from 'react';
import { useLocation } from 'react-router-dom';

import {
  StreamApp,
  SinglePost,
  StatusUpdateForm,
  FlatFeed,
  NotificationDropdown,
  Activity,
  ActivityFooter,
  LikeButton,
  CommentField,
  CommentList,
  CommentItem,
  InfiniteScrollPaginator,
} from 'react-activity-feed';

// import './compiled-all-component-styles.css';
// import './about-app-styles.css';
import '../styles/try-our-own-sass.scss';

import { Tiger21Activity } from '../components/tiger21/Tiger21Activity';
import TopLevelCommentItem from '../components/tiger21/TopLevelCommentItem';
import TigerCommentField from '../components/tiger21/TigerCommentField';

import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

import communityItems from '../data/items.json';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function SinglePostFromId() {
  let hardcodedId = '2db53080-3066-11ed-8080-80012d6861ba';

  let query = useQuery();
  const appId: string = query.get('appId') ?? 'handle-value-not-passed';
  const apiKey: string = query.get('apiKey') ?? 'handle-value-not-passed';
  const token: string = query.get('token') ?? 'handle-value-not-passed';
  const feedGroup: string = query.get('feedGroup') ?? 'handle-value-not-passed';
  const feedId: string = query.get('feedId') ?? 'handle-value-not-passed';
  const activityId: string =
    query.get('activityId') ?? 'handle-value-not-passed';

  // NAME: `T21C App - Dev`, APP ID: `1206230`, KEY: `p4ryzhnn9944`
  // User `U--t21c_chair2-1` has Client side JWT token `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiVS0tdDIxY19jaGFpcjItMSJ9.JqzSnvsRp4e1r4axdiwTA6Zc9jNLkXgIj5XlwYubtb0`
  // =========
  // NAME: `T21C App - UAT`, APP ID: `1207176`, KEY: `2eufbnqykjuh`
  // User `U--james_salmon` has Client side JWT token `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiVS0tamFtZXNfc2FsbW9uIn0.9Zbq_0JfjeqgI1vxSCAItNYe_jQF-71zanMHTi4Cu6E`
  // =========
  // NAME: `T21C Stream UAT`, APP ID: `1173466`, KEY: `t478j3apqbjz`
  // User `U--jamessalmon` has Client side JWT token `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiVS0tamFtZXNzYWxtb24ifQ.NJpxC6p2FNPgbA4G_abWEehgJmiXgFCGvpbq8llQ8UE`
  // =========

  return (
    <>
      <div style={{ width: '600px', margin: '0' }}>
        <StreamApp appId={appId} apiKey={apiKey} token={token}>
          <SinglePost
            activityId={activityId}
            feedGroup={feedGroup}
            notify
            options={{
              limit: 20,
              withOwnChildren: true,
              withRecentReactions: true,
            }}
            Paginator={InfiniteScrollPaginator}
            Activity={({ activity, feedGroup, userId }) => (
              <Activity
                activity={activity}
                feedGroup={feedGroup}
                userId={userId}
                Footer={() => (
                  <>
                    <LikeButton activity={activity} />

                    <CommentField activity={activity} />
                    <TigerCommentField
                      activity={activity}
                      placeholder='Write a comment...'
                    />
                    <CommentList
                      activityId={activity.id}
                      reverseOrder={true}
                      // Paginator={InfiniteScrollPaginator}
                      CommentItem={({ comment }) => {
                        return (
                          <div>
                            <TopLevelCommentItem comment={comment} />
                          </div>
                        );
                      }}
                    />
                  </>
                )}
              />
            )}
          />
        </StreamApp>
      </div>
    </>
  );
}
